"use client"

import Script from "next/script"
import { useId } from "react"
import type { Offer } from "../../types"

interface Props {
  item: Offer.Faq["faq"]
}

export const FaqSchemaJsonLd = ({ item }: Props) => {
  const id = useId()

  return (
    <Script type="application/ld+json" id={`json-ld-faq-${id}`}>
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": item.map((faq) => ({
          "@type": "Question",
          "name": faq.question,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": faq.answer,
          },
        })),
      })}
    </Script>
  )
}
